// extracted by mini-css-extract-plugin
export default {"mainWrapper":"PaddingContainer_mainWrapper__oj2UM"};